export const SET_PRODUCT_TYPES = 'SET_PRODUCT_TYPES';
export const SET_PRODUCT_TYPES_LOADING = 'SET_PRODUCT_TYPES_LOADING';
export const SET_PRODUCT_TYPES_ERROR = 'SET_PRODUCT_TYPES_ERROR';
export const SET_ACTIVE_TYPE = 'SET_ACTIVE_TYPE';
export const ADD_PRODUCT_TYPE = 'ADD_PRODUCT_TYPE';
export const UPDATE_PRODUCT_TYPE = 'UPDATE_PRODUCT_TYPE';
export const DELETE_PRODUCT_TYPE = 'DELETE_PRODUCT_TYPE';
